import { render, staticRenderFns } from "./MassTextLog.vue?vue&type=template&id=f24cb582&"
import script from "./MassTextLog.vue?vue&type=script&lang=js&"
export * from "./MassTextLog.vue?vue&type=script&lang=js&"
import style0 from "./MassTextLog.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MassTextLog.vue"
export default component.exports